/**
 * URL parametrelerini yönetmek için basitleştirilmiş yardımcı sınıf.
 */
export class URLParams {
  private params: URLSearchParams;

  constructor() {
    try {
      this.params = new URLSearchParams(window.location.search);
    } catch (e) {
      console.error("URL parametreleri çözümlenirken hata:", e);
      this.params = new URLSearchParams();
    }
  }

  /**
   * Parametre değerini al
   */
  get(param: string): string | null {
    return this.params.get(param);
  }

  /**
   * Parametre var mı kontrol et
   */
  has(param: string): boolean {
    return this.params.has(param);
  }

  /**
   * Tüm parametreleri al
   */
  getAll(): Record<string, string> {
    const result: Record<string, string> = {};
    this.params.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
}
